export default "/assets/images/badge-01.de55f8e688773484.png";